import React from 'react'
import { bool, string } from 'prop-types'
import cx from 'classnames'

import styles from './loading-animation.module.css'

const propTypes = {
    circleClassName: string,
    noDelay: bool
}

function LoadingAnimation({ circleClassName, className, noDelay }) {
    const delayInSeconds = noDelay ? 0 : 0.35 // in seconds
    return (
        <div className={cx(styles['svg-container'], className)}>
            <svg viewBox="0 0 56 20" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="0" className={cx(styles['circle'], circleClassName)}>
                    <animate
                        id="first"
                        attributeName="r"
                        values="0;8;0"
                        dur="1.4s"
                        begin={`${0 + delayInSeconds}s;third.end`}
                        calcMode="paced"
                    />
                </circle>
                <circle cx="28" cy="10" r="0" className={cx(styles['circle'], circleClassName)}>
                    <animate
                        id="second"
                        attributeName="r"
                        values="0;8;0"
                        dur="1.4s"
                        begin={`${0.16 + delayInSeconds}s;third.end+0.16`}
                        calcMode="paced"
                    />
                </circle>
                <circle cx="46" cy="10" r="0" className={cx(styles['circle'], circleClassName)}>
                    <animate
                        id="third"
                        attributeName="r"
                        values="0;8;0"
                        dur="1.4s"
                        begin={`${0.32 + delayInSeconds}s;third.end+0.32`}
                        calcMode="paced"
                    />
                </circle>
            </svg>
        </div>
    )
}

LoadingAnimation.propTypes = propTypes

export { LoadingAnimation }
